import React, { useEffect, useState } from "react";
import icon5 from "../../Assets/Image/admin/5.png";
import { MdBlock } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { Dumbbell, Images } from "lucide-react";
import { Bars } from "react-loader-spinner";
import nodata from "../../Assets/Image/admin/nodata.png";
import { getdashboardCount } from "../../Services/ApiServices";
import toast from "react-hot-toast";

function Dashboard() {
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [newCount, setNewCount] = useState({});

  const handleDashbord = () => {
    setLoader(true)
    getdashboardCount()
      .then((res) => {
        setNewCount(res?.data?.data)
        setLoader(false)
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          localStorage.removeItem("token");
          navigate("/login");
        } else {
          toast.error(err?.response?.data?.message);
        }
        setLoader(false);
      })
  };

  useEffect(() => {
    handleDashbord();
  }, []);

  return (
    <>
      <div className="grid grid-cols-12 gap-4 fontNew md:m-4 m-1">
        <div className="col-span-12">
          <div>
            <div className="grid grid-cols-12 gap-4">
              {loader ? (
                <div className="flex justify-center items-center col-span-12 h-[70vh]">
                  <Bars
                    height="35"
                    width="35"
                    color="#FF4433"
                    ariaLabel="bars-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={true}
                  />
                </div>
              ) : (
                <>
                  {!newCount ? (
                    <div className="col-span-12 h-[50vh] justify-center flex items-center">
                      <img src={nodata} className="w-28" alt="No data" />
                    </div>
                  ) : (
                    <>
                      <div
                        onClick={() => {
                          navigate("/users", { state: { flag: 0 } });
                        }}
                        className="2xl:col-span-3 xl:col-span-4 lg:col-span-6 sm:col-span-6 col-span-12 bg-white p-5 rounded-2xl fontNew hover:drop-shadow-lg duration-300 cursor-pointer"
                      >
                        <img src={icon5} className="w-12 py-2" alt="" />
                        <p className="text-4xl pb-3 font-semibold my-2">
                          {newCount.totalUsers || "0"}
                        </p>
                        <p className="text-base">Total Users</p>
                      </div>
                      <div
                        onClick={() => {
                          navigate("/all_post");
                        }}
                        className="2xl:col-span-3 xl:col-span-4 lg:col-span-6 sm:col-span-6 col-span-12 bg-white p-5 rounded-2xl fontNew hover:drop-shadow-lg duration-300 cursor-pointer"
                      >
                        <div className="bg-[#5B93FF] w-12 h-12 rounded-full flex justify-center items-center my-2">
                          <Images color="white" size={24} />
                        </div>
                        <p className="text-4xl pb-3 font-semibold py-2">
                          {newCount.totalPost || "0"}
                        </p>
                        <p className="text-base">Total Posts</p>
                      </div>
                      <div
                        onClick={() => {
                          navigate("/excercise");
                        }}
                        className="2xl:col-span-3 xl:col-span-4 lg:col-span-6 sm:col-span-6 col-span-12 bg-white p-5 rounded-2xl fontNew hover:drop-shadow-lg duration-300 cursor-pointer"
                      >
                        <div className="bg-[#2c8083] w-12 h-12 rounded-full flex justify-center items-center my-2">
                          <Dumbbell className="text-white" />
                        </div>
                        <p className="text-4xl pb-3 font-semibold py-2">
                          {newCount.totalExercise || "0"}
                        </p>
                        <p className="text-base">Total Excercise</p>
                      </div>
                      <div
                        onClick={() => {
                          navigate("/users", { state: { flag: 1 } });
                        }}
                        className="2xl:col-span-3 xl:col-span-4 lg:col-span-6 sm:col-span-6 col-span-12 bg-white p-5 rounded-2xl fontNew hover:drop-shadow-lg duration-300 cursor-pointer"
                      >
                        <div className="bg-[#FF4433] w-12 h-12 rounded-full flex justify-center items-center my-2">
                          <MdBlock className="text-white text-2xl" />
                        </div>
                        <p className="text-4xl pb-3 font-semibold py-2">
                          {newCount.totalBlockedUser || "0"}
                        </p>
                        <p className="text-base">Total Blocked User</p>
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Dashboard;
